export const routeConfig = {
  meta: {
    title: '融资申请查询',
  },
};
